
/* Change this file to get your personal Portfolio */

// Your Summary And Greeting Section

import emoji from "react-easy-emoji";

const greeting = {
  /* Your Summary And Greeting Section */
  username: "Saadeddine Louati",
  title: "Hi all, I'm Saad",
  subTitle: emoji("A passionate Software Developer 🚀 and freelancer having an experience of building Web and Mobile applications with JavaScript / Reactjs / Nodejs / React Native and some other cool libraries and frameworks."),
  resumeLink: "https://drive.google.com/file/d/1CwLp8Ua9tLzg1-qosCVtMf87dNf-yyU5/view?usp=sharing"
};

// Your Social Media Link

const socialMediaLinks = {

  github: "https://github.com/saadeddineLouati",
  linkedin: "https://www.linkedin.com/in/saadeddine-louati/",
  gmail: "saadlouatiii@gmail.com",
  gitlab: "https://gitlab.com/saadeddineLouati",
  facebook: "https://www.facebook.com/saad.loueti",
  medium: "https://medium.com/@saadlouatiii",
  stackoverflow: "https://stackoverflow.com/users/12677906/saadeddine-louati"
  // Instagram and Twitter are also supported in the links!
};

// Your Skills Section

const skillsSection = {
  title: "What i do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji("⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji("⚡ Integration of third party services such as Firebase/ AWS / Umbrella payment services")
  ],

  /* Make Sure You include correct Font Awesome Classname to view your icon
  https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }, {
      skillName: 'umbrella payment',
      fontAwesomeClassname: "fas fa-umbrella",
    }, {
      skillName: 'java',
      fontAwesomeClassname: "fab fa-java",
    }, {
      skillName: 'git',
      fontAwesomeClassname: "fab fa-git-alt",
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design",  //Insert stack or technology you have experience in
      progressPercentage: "70%"  //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "90%"
    },
    {
      Stack: "Programming",
      progressPercentage: "80%"
    }
  ]
};


// Your top 3 work experiences

const workExperiences = {
  viewExperiences: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer / Project Manager",
      company: "Galactech",
      companylogo: require("./assets/images/galactech.jpg"),
      date: "July 2020 – Present",
      desc: "Execute full software development life cycle (SDLC), Develop flowcharts, layouts and documentation to identify requirements and solutions and Write well-designed, testable code",
      descBullets: [
        "Design thinking",
        "Brainstoarming",
        "UML",
        "DEVOPS AWS",
        "Node.js express React.js MongoDB Service worker",
        "SCRUM ASANA Trello",
        "Umbrella payment services",
      ]
    },
    {
      role: "Part time developer - MERN stack",
      company: "Galactech",
      companylogo: require("./assets/images/galactech.jpg"),
      date: "Sep 2019 – Juin 2020",
      desc: "Create and test applications, Present design specs, Maintain and update websites and Monitor website traffic",
      descBullets: [
        "Live streaming",
        "Progressive web app",
        "UML",
        "DEVOPS AWS",
        "Node.js express React.js MongoDB Service worker",
        "SCRUM ASANA Trello",
        "Umbrella payment services",
        "Data analysis"
      ]
    },
    {
      role: "Web developer intern",
      company: "Galactech",
      companylogo: require("./assets/images/galactech.jpg"),
      date: "Juin 2019 – Sep 2019",
      desc: "Assist in gathering and refining specifications and requirements based on technical needs, Collaborates with web designers to match intent of visual design and Keep up to date into emerging technologies/industry trends and apply them into operations and activities.",
      descBullets: [
        "Progressive web app",
        "UML",
        "DEVOPS AWS",
        "Node.js express React.js MongoDB Service worker",
        "SCRUM ASANA Trello",
        "Umbrella payment services",
      ]
    },
    {
      role: "Bachelor’s degree final study project",
      company: "STEG",
      companylogo: require("./assets/images/steg.png"),
      date: "Fev 2017 – Mai 2017",
      desc: "Undertaking an autonomous project under the direction of a tutor, Web application development for the management of variable post agents in relation with the vehicle park Based on shortest path strategies",
      descBullets: [
        "JAVA_EE",
        "MVC",
        "SCRUM",
        "MicroServices ",
        "SQL(MySQL) ",
        "JQUERY",
        "BOOTSTARP",
        "Tomcat",
      ]
    },
    {
      role: "System Administrator",
      company: "Martelli Tunisie",
      companylogo: require("./assets/images/martelli.jpg"),
      date: "Juin 2016",
      desc: "Responsible for: creating and hosting the web site to the IIS server requiring daily attention to speed and crashing issues, ensuring the proper functioning of the system and network and SAFEGUARDING AND RESTORATION",
      descBullets: [
        "Windows server",
        "Linux", "DHCP", "VMWARE", "Firewall", "Active directory"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: "dcfa82222be16d68f445dc471ab476ebb7e0781e",
  githubUserName: "saadeddineLouati", // Change to your github username to view your profile in Contact Section.
  showGithubProfile: "true" // Set true or false to show Contact profile using Github, defaults to false 
};


// Some Big Projects You have worked with your company

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/omg.png"),
      link: "https://ohmygame.io/"
    },
    {
      image: require("./assets/images/galactech.jpg"),
      link: "https://www.galactechstudio.com/"
    }
  ]
};

// Your Achievement Section Include Your Certification Talks and More

const achievementSection = {

  title: emoji("Achievements And Certifications 🏆 "),
  subtitle: "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achivementsCards: [
    {
      title: "MTA: Software Development Fundamentals",
      subtitle: "The MTA program provides an appropriate entry point to a future career in technology. A certificate verifiable by employers",
      image: require("./assets/images/MTA-Software-Development-Fundamentals-2018.png"),
      footerLink: [
        { name: "Certification", url: "https://www.youracclaim.com/badges/cac8cf3c-b677-41d8-9a9f-23eb9f9e84a7/linked_in_profile" },
      ]
    },
    {
      title: "Voltaire Certificate: Certification in french spelling",
      subtitle: "A certificate verifiable by employers",
      image: require("./assets/images/voltaireLogo.jpg"),
      footerLink: [{ name: "Certification", url: "https://www.certificat-voltaire.fr/orthographe-recruteur?code=6VFWDG" }]
    },

    {
      title: "TCF (Test de connaissances du français)",
      subtitle: "The Test de connaissance du français is a language placement test for non-native speakers of French.",
      image: require("./assets/images/Logo-TCF-rvb.jpg"),
      footerLink: [
        { name: "Certification", url: "./011.jpg" },
      ]
    }
  ]
};

// Blogs Section

const blogSection = {

  title: "Portfolio",
  subtitle: emoji("I LOVE TO SHARE MY LIMITED KNOWLEDGE🤗, here are some simple projects, please note that i have more with backends but i can't host them"),

  blogs: [
    {
      url: "https://tfakkarni-react-game-by-saad.firebaseapp.com/",
      title: "'TFAKKARNI', Simple react game with dark/light mode ",
      description: "122px",
      image: require("./assets/images/tfakkarni-react-game-by-saad.firebaseapp.com_(iPhone 6_7_8 Plus) (1).png"),
    },
    {
      url: "https://random-news-paper.firebaseapp.com/",
      title: "Simple react news application, using 'Lorem ipsum' random text API",
      description: "auto",
      image: require("./assets/images/random-news-paper.firebaseapp.com_(Laptop with MDPI screen).png"),
    },
    {
      url: "https://dashboardini-react-app-by-saad.firebaseapp.com/#/login",
      title: "'DASHBOARDINI', Simple react CRUD application, built for managment purposes",
      description: "122px",
      image: require("./assets/images/dashboardini-react-app-by-saad.firebaseapp.com_(iPhone 6_7_8 Plus) (2).png"),
    },
    {
      url: "https://easyweather.firebaseapp.com/",
      title: "'Easy Weather', Simple react weather application",
      description: "auto",
      image: require("./assets/images/easyweather.firebaseapp.com_(Laptop with MDPI screen).png"),
    },
    {
      url: "https://echrini.firebaseapp.com/",
      title: "'ECHRINI', Simple e-commerce application",
      description: "auto",
      image: require("./assets/images/echrini.firebaseapp.com_products(Laptop with MDPI screen).png"),
    },
    {
      url: "https://fallasni-by-saad.firebaseapp.com/",
      title: "'FALLASNI', Simple react TECH-SHOP",
      description: "auto",
      image: require("./assets/images/fallasni-by-saad.firebaseapp.com_(Laptop with MDPI screen) (1).png"),
    },
    {
      url: "https://taskini-react-app-by-saad.firebaseapp.com/",
      title: "'TASKINI', Simple react task manager application",
      description: "122px",
      image: require("./assets/images/taskini-react-app-by-saad.firebaseapp.com_(iPhone 6_7_8 Plus).png"),
    }
  ]
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji("I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"),

  talks: [
    // {
    //   title: "Build Actions For Google Assistant",
    //   subtitle: "Codelab at GDG DevFest Karachi 2019",
    //   slides_url: "https://bit.ly/saadpasta-slides",
    //   event_url: "https://www.facebook.com/events/2339906106275053/"
    // }
  ]
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: ["https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"]
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle: "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+216 53596133",
  email_address: "saadlouatiii@gmail.com"
};

//Twitter Section

const twitterDetails = {

  userName: "twitter"//Replace "twitter" with your twitter username without @

};
export { greeting, socialMediaLinks, skillsSection, techStack, workExperiences, openSource, bigProjects, achievementSection, blogSection, talkSection, podcastSection, contactInfo, twitterDetails };
